// Concern hero photography — one editorial image per concern at /images/concerns/{family}/{slug}.webp (1264×848).
const ALT = {
  "face/frown-and-forehead-lines": "Woman with eyes closed, natural forehead and frown lines visible at rest",
  "face/crows-feet-and-eye-area": "Close-up of the outer corner of a smiling eye with fine crow's feet",
  "face/volume-loss-and-flattening": "Side-lit portrait showing natural hollowing beneath the cheekbone",
  "face/jawline-and-jowls": "Profile of a woman with a softened jawline and early jowls",
  "face/lips": "Close-up of natural, unretouched lips with fine lip lines",
  "face/under-eye-hollows-and-dark-circles": "Close-up of eyes with under-eye hollows and darker circles",
  "face/facial-asymmetry": "Front-on portrait showing natural facial asymmetry",
  "face/teeth-grinding-and-jaw-tension": "Man pressing fingertips to a tense jaw muscle",
  "skin/skin-quality-and-texture": "Macro of cheek skin showing pores and fine lines",
  "skin/pigmentation-and-sun-damage": "Cheek and temple with freckles and sun spots",
  "skin/skin-checks-and-lesions": "Doctor examining a mole on a patient's back with a dermatoscope",
  "skin/acne": "Young woman with active acne along the jaw and cheek",
  "skin/acne-scarring": "Man's cheek with pitted acne scars in side light",
  "skin/redness-and-rosacea": "Fair-skinned woman with flushing across the cheeks and nose",
  "skin/dehydration-and-dullness": "Woman pressing moisturiser to dull, dehydrated skin",
  "skin/scarring-and-stretch-marks": "Hip with natural stretch marks in soft light",
  "hair/male-pattern": "Man with receding temples and a thinning crown reading by a window",
  "hair/crown-thinning": "Looking down at a thinning crown",
  "hair/female-thinning": "Woman's widened centre parting seen from above",
  "hair/hairline-and-temples": "Man with temple recession touching his hairline",
  "hair/eyebrows": "Close-up of a sparse, thinning eyebrow",
  "hair/scalp-health": "Fingertips parting hair to show an irritated scalp",
  "body/body-shape-and-muscle-tone": "Woman in linen activewear standing side-on in a sunlit room",
  "body/stubborn-fat": "Hand resting on a stubborn pocket at the lower abdomen",
  "body/weight-and-metabolic-health": "Man walking along a quiet beach at golden hour",
  "body/pelvic-floor-and-continence": "Woman doing a gentle bridge exercise on a mat",
  "body/energy-sleep-and-ageing-well": "Woman stretching in bed in early morning light",
  "body/excessive-sweating": "Man adjusting his collar with a visible sweat patch under the arm",
  "life-stages/preparing-for-a-wedding": "Bride-to-be checking her skin in a hand mirror, veil behind",
  "life-stages/after-pregnancy": "New mother holding her sleeping baby by a window",
  "life-stages/perimenopause-and-menopause": "Woman with silver-streaked hair resting a hand on her cheek",
  "life-stages/mens-concerns": "Man in his forties with natural lines looking off camera",
  "life-stages/your-first-treatment": "Young woman listening to a doctor in a light consulting room",
  "life-stages/correcting-previous-work": "Woman studying her face in a hand mirror",
};

const POS = {
  "face/lips": "50% 50%",
  "skin/skin-checks-and-lesions": "60% 40%",
  "hair/male-pattern": "50% 22%",
  "hair/crown-thinning": "50% 25%",
  "hair/female-thinning": "50% 18%",
  "body/weight-and-metabolic-health": "45% 50%",
  "body/pelvic-floor-and-continence": "50% 55%",
  "life-stages/your-first-treatment": "65% 40%",
};

export const concernImage = (family, slug) => {
  const key = `${family}/${slug}`;
  return { id: `/images/concerns/${key}.webp`, pos: POS[key] || "50% 32%", alt: ALT[key] || "" };
};
